import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import { Syllabu } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./SyllabuForm.form";

const syllabuController = new Syllabu();

export function SyllabuForm(props) {
  const { onClose, onReload, syllabu } = props;
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: initialValues(syllabu),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        const data = {
          name: formValue.name,
        };

        if (syllabu) {
          await syllabuController.updateSyllabu(accessToken, syllabu.id, data);
        } else {
          data.status = 1;
          await syllabuController.createSyllabu(accessToken, data);
        }
        onReload();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Input
        name="name"
        label="Nombre de malla curricular"
        onChange={formik.handleChange}
        value={formik.values.name}
        error={formik.errors.name}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {syllabu ? "Actualizar malla curricular" : "Crear malla curricular"}
      </Form.Button>
    </Form>
  );
}